<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" content="添加分类"></el-page-header>
        <el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
            <el-form-item label="所属行业" prop="industry_id">
                <template>
                    <el-select v-model="item.industry_id" filterable placeholder="请选择">
                        <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </template>
            </el-form-item>
            <el-form-item label="上级分类">
                <div class="block">
                    <el-cascader v-model="item.parent_id"
                         placeholder="不选择则作为一级分类"
                         :options="optionsParent"
                         :props="filterProps"
                         clearable></el-cascader>
                </div>
            </el-form-item>
            <el-form-item label="分类名称" prop="name">
                <el-input v-model="item.name" placeholder="请输入分类名称" class="el-input-default-width-220"></el-input>
            </el-form-item>
            <el-form-item label="排序号" prop="orders">
                <el-input v-model="item.orders" placeholder="请输入排序号" class="el-input-default-width-220"></el-input>
            </el-form-item>
            <el-form-item label="分类图标" prop="logo">
                <el-upload
                        class="single-image"
                        list-type="single-image"
                        :on-success="(value) => uploadSuccess('logo', value)"
                        :show-file-list="false"
                        :action="app_url + '/supplier/uploader/upload'">
                    <i class="icon el-icon-plus" v-if="!item.logo"></i>
                    <img :src="item.logo" v-else>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="checkSubmit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {
					orders: 1,
                    logo: ''
				},
                filterProps: {
                    value: 'id',
                    label: 'name',
                    emitPath: false,
                    checkStrictly: true
                },
                isLoad: false,
                logo: [],
                optionsParent: [],
                options: [],
                rules: {
                    industry_id: [
                        {required: true, message: '所属行业不存在', trigger: 'blur'},
                    ],
                    name: [
                        {required: true, message: '分类名称不存在', trigger: 'blur'},
                    ],
                    // logo: [
                    //     {required: true, message: '分类图标不存在'},
                    // ],
                }
            }
        },
        created() {
          this.loadData()
        },
        methods: {
            loadData: function () {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.get('/supplier/data/listIndustryForSelect', {},
				).then(res => {
					this.options = res.data.list;
                    return this.axios.get('/supplier/data/getCategoryTreeSupplier', {
                    })
                }).then(res => {
                    this.isLoad = !this.isLoad
                    this.optionsParent = res.data.tree
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            checkSubmit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.submit()
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },
            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad

				let url = '/supplier/productCategory/add'
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
            },
            uploadError() {
                this.$message.error({
                    message: '上传失败'
                });
            },
            beforeUpload(file) {
                var testmsg = file.type;
                const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
                if (!extension ) {
                    this.$message({
                        message: "上传文件只能是jpg或png格式!",
                        type: "warning",
                    });
                }
                return extension;
            },
            uploadSuccess(key, res, file) {
                this.item[key] = res.data.fileInfo.external_url
            },
            uploadRemove: function () {
                this.logo = []
            }
        }
    }
</script>
<style scoped>
    .single-image .icon,.single-image img{
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
    }
</style>
